import { getStatusBadge, getStatusText } from "../../lib/utils";

interface StoryStatusBadgeProps {
    status: string;
}

export function StoryStatusBadge({ status }: StoryStatusBadgeProps) {
    return <span className={`text-xs px-2 py-1 rounded-full ${getStatusBadge(status)}`}>{getStatusText(status)}</span>;
}
